const message = {
  show(element: HTMLElement, text = '', type = 'error', timer = 10000): void {
    element.style.display = 'block'

    if (text) {
      element.innerHTML = text
    }

    element.classList.add(`message--${type}`)

    if (timer > 0) {
      setTimeout(() => {
        this.reset(element)
      }, timer)
    }
  },

  reset(element: HTMLElement, clearText = false, type = 'error'): void {
    element.style.display = 'none'

    if (clearText) {
      element.innerHTML = ''
    }

    element.classList.remove(`message--${type}`)
  },
}

export default message
